// extracted by mini-css-extract-plugin
export default {"basicInformationSection":"BaseForm_basicInformationSection__c5ntz","showInApp":"BaseForm_showInApp__Gt-NR","showLabel":"BaseForm_showLabel__Rb8H8"};